import { useEffect, useState } from "react";
import { ICall } from "./index";
import { LuDoorOpen } from "react-icons/lu";

interface IInfoProps {
  id: string;
  call: ICall;
}

export default function Info({ call, id }: IInfoProps) {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    setAnimation(true);
  }, [id]);

  return (
    <section className="painel-call-card">
      <div className="painel-call-content">
        <span className="painel-senha-label">SENHA</span>
        <div className="painel-senha-number-box">
          <span
            className={`painel-senha-number ${animation ? "texto-piscante" : ""}`}
            onAnimationEnd={() => setAnimation(false)}
          >
            {call?.password}
          </span>
        </div>
        {call?.name && call.name.length > 0 && (
          <span className={`painel-senha-name ${animation ? "texto-piscante" : ""}`}>
            {call.name}
          </span>
        )}
      </div>
      <div className="painel-call-local-bar">
        <LuDoorOpen size={38} />
        <span className="painel-call-local-bar-text">{call?.local}</span>
      </div>
    </section>
  );
}
